import { Limits } from '@studio/models/video/preset';
import type { Preset } from '@studio/models/video/preset';
import { forwardRef } from 'react';
import type { Props } from './types.js';
import { Editable, Thumbnail } from '#~/common/card/index.js';
import type { Behavior } from '#~/common/card/index.js';

/** Image settings preset `<Card>` component. */
export const Card = forwardRef<Behavior, Props>(({ handler, preset, ...props }, forwardedRef) => {
  const { thumbnail, ...item } = preset;

  return (
    <Editable<Preset>
      forwardedRef={forwardedRef}
      handler={{
        ...handler,
        onSettings: (id: Preset['id']): void => {
          handler.onRemove(id);
        }
      }}
      item={item}
      maxLength={Limits.name}
      settings='trash'
      {...props}
    >
      <Thumbnail image={thumbnail} title={item.name} />
    </Editable>
  );
});
